/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

export default {
  energyManagement: {
    REFRESH: 'Opdater',
    ENERGYPERFORMANCE: 'Energibesparelser',
    UTILITYBILLSAVINGS: 'Opkrævninger på forsyningsregninger ',
    DateFrom: 'Fra datoen',
    SITES: 'Steder',
    ENERGYMANAGEMENTDASHBOARDTITLE: 'Energistyringsscore',
    BASELINE: 'Basis',
    BASELINEKEY: 'baselineConsumption',
    ACTUALKEY: 'ActualConsumption',
    SAVINGS: 'Besparelser',
    ACTUAL: 'Faktisk',
    PARTIAL_MONTH: 'Delvis måned',
    ACTUALEMISSIONS: 'Faktiske emissioner',
    ACTUALEMIS: 'Faktisk udledning',
    PREVIOUSEMIS: 'Forrige udledning',
    PREVIOUSEMISSIONS: 'Tidligere emissioner',
    TOTALCONSUMPTION: 'Samlet forbrug',
    EMISSION: 'Emissioner',
    ACTUALAVOIDANCE: 'Faktisk reduktion',
    PREVIOUSPERIOD: 'Tidligere periode',
    PREVIOUS: 'Foregående',
    PREVIOUSAVOIDANCE: 'Forrige reduktion',
    ACTUALCOST: 'Faktiske omkostninger',
    actualCost: 'FAKTISK FORB.',
    BASELINECOST: 'Basisomkostninger',
    baselineCost: 'BASISFORBRUG',
    PREVSPER: 'TIDLIGERE PERIODE',
    PREVIOUSCOST: 'Foregående omkostninger',
    VIEWDETAILS: 'VIS DETALJER',
    ADVANCED: 'Avanceret',
    BASIC: 'Basis',
    MONTHLY: 'Månedligt',
    BILLING: 'Fakturering',
    LIVEMETER: 'Live-målere',
    UTILITYMETER: 'Forbrugsmålere',
    LIVEREADING: 'Onsite målere',
    UTILITYINTERVAL: 'Forbrugsinterval',
    UTILITYPROVIDERNEW: 'Forsyning, månedligt',
    ACTUALCONSUMPTION: 'Faktisk forbrug',
    BASELINECONSUMPTION: 'Basisforbrug',
    PREDICTED: 'Forudsagt',
    Utilitycost: 'Forsyningsomkostninger for',
    UtilityBill: 'Oversigt over forsyningsregning',
    UtilityCost: 'Forsyningsomkostninger',
    ActualCost: 'Faktiske omkostninger',
    CostPercentage: 'Omkostning i %',
    Electricity: 'Elektricitet',
    Gas: 'Gas',
    Water: 'Vand',
    UtilityType: 'Forsyningstype',
    all: 'alle',
    electricity: 'elektricitet',
    gas: 'gas',
    water: 'vand',
    BASICSITEWITHDATACOUNTMESSAGE:
      '* Der er genereret regninger for energiforbrug for {siteWithDataCount} af {totalSiteCount} steder.',
    CARBONUTILITYGRAPHTOOLTIP:
      '* Der er genereret udledninger for forsyningsregninger for {siteWithDataCount} af {totalSiteCount} steder.',
    CARBONLIVEGRAPHTOOLTIP:
      '* Der er genereret udledninger for live-aflæsninger for {siteWithDataCount} af {totalSiteCount} steder.',
    ENERGYUTILITYGRAPHTOOLTIP:
      '* Der er genereret regninger for energiforbrug for {siteWithDataCount} af {totalSiteCount} steder.',
    ENERGYLIVEGRAPHTOOLTIP:
      '* Der er genereret live-aflæsninger for {siteWithDataCount} af {totalSiteCount} steder.',
    UtilityTypeforselectutility: 'Forsyningstype*',
    ENABLEIDSCHECKBOX: 'Aktiver IDS (Interval Data Service)',
    ENABLED: 'Aktiveret',
    DISABLED: 'Deaktiveret',
    CONVERSIONINFOMSG:
      "Angiv venligst dine legitimationsoplysninger for at muliggøre konvertering af dette kontonummer fra en 'manuel' til en 'automatisk' integrationstype. Når \n    legitimationsoplysningerne er verificeret, bliver integrationstypen automatisk opdateret. De manuelt gemte data vil blive bevaret, og de kommende regninger \n    vil derefter blive opdateret automatisk.",
    CO2: 'CO2',
    CARBON: 'CO2({unit})',
    CARBONNOUNIT: 'Kulstof',
    CARBONEMISSION: 'CO2-udledninger',
    METERDATA1: 'Målerdata',
    DATANEEDED: 'Nødvendige data',
    METERDATA: 'Målerdata',
    METERDATASUBTITLE:
      'Analyser og sammenlign målerforbrug ved at uploade historiske og/eller manglende periodedata.',
    EUI: 'EUI({preferredEuiUnit})',
    ELECTRICITYCONSUMPTION: 'ELFORBRUG',
    ELECTRICITYPERFORMANCE: 'El-ydelse',
    Electicity:
      ' El-, gas- og vanddata kan integreres ved at sammenkæde dine konti',
    FORECAST: 'Prognose',
    ALL: 'Alle',
    ELECTRICITY: 'Elektricitet',
    GAS: 'Gas',
    WATER: 'Vand',
    METER: 'MÅLER',
    SavingMeter: 'Besparelser efter måler',
    BREAKDOWNMETER: 'Forb. efter målere',
    BREAKDOWNBYAREAS: 'Opdeling efter områder',
    BREAKDOWNBYEQUIPMENTTYPE: 'Opdeling efter udstyrstype',
    CONSUMPTIONBYUTILITIES: 'Forb. efter forsyning',
    ENERGYBREAKDOWNOFUTILITY: 'Opdeling af forsyning',
    ENERGYBREAKDOWNBYMETERS: 'Opdeling efter målere',
    WATERBREAKDOWNBYLIVEMETERS: 'Opdeling efter live-målere',
    BREAKDOWNOFUTILITY: 'Opdeling af forsyningsomkostninger',
    breakdownUtility: 'Opdeling efter forsyninger',
    breakdownCarbon: 'Opdeling af målere',
    breakdownCarbonScopeOne: 'Opdeling efter kategori',
    breakdownFuel: 'Opdeling af brændstoftyper',
    breakdownAreas: 'Opdeling efter områder',
    areasHeader: ' Områder',
    metersHeader: 'Målere',
    areasSubHeaders:
      'Følgende opdeling af elforbruget er i henhold til områder og for valgt varighed.',
    baselinebutton: 'Opret baseline',
    LAST_BASELINE_TRAINED_DATE: 'Sidste basis trænet på',
    apply: 'Anvend',
    back: 'Tilbage',
    baselinetraning: 'Basistræning',
    chooseTrainingDateRange: 'Vælg datointerval for træning',
    applyBaselineFrom: 'Anvend baseline fra',
    historicDataTooltip:
      'Når det gælder de uploadede historiske data, vil basisværdien være synlig for de sidste 15 dage i dashboardet og rapporterne.',
    excludeSpecificDateRangeQ:
      'Foretrækker du at ekskludere et bestemt datointerval?',
    excludeDateRange: 'Ekskluder datointerval',
    howitworks: 'Hvordan virker det?',
    howitworksone:
      'Alle de uploadede målerdata vil blive brugt til at træne en basismodel af god kvalitet',
    howitworkstwo:
      'Basisdataene vil blive vist på dashboardet og i rapporter for de sidste 15 dage fra uploaddatoen',
    howitworksthree:
      'For at opnå de bedste baseline resultater anbefales det at have 12 måneders data',
    howitworksfour: 'Der kræves mindst 30 dages data til modeltræning',
    howitworksfive: 'Grundlinjetræning anvendes på data fra alle sitemålere',
    howitworkssix:
      'Når du træner basismodellen igen, vil den eksisterende model blive erstattet baseret på den nye basistræningsperiode',
    baselinedaterangeheader: 'Vælg basistræningsperiode',
    baselinedaterangesubheader:
      'Vælg datointervallet for basismodellen, uanset om du ønsker at inkludere eller ekskludere en bestemt periode.',
    redirectmsg1: 'Du bliver omdirigeret om',
    redirectmsg2: 'sek.',
    uploadingmsg:
      'Vent, mens vi indleder processen med at træne basisværdien. Vi giver dig besked via e-mail, når det er gjort.',
    meterSubHeaders:
      "Tabellen viser en opdeling af målere på stedet sammen med forskellige KPI'er.",
    breakdownCarbonSites: 'CO2-udledninger efter steder ({count})',
    ENERGYUSAGE: 'Energiforbrug',
    ENERGYUSAGECONSUMPTION: 'Forbrug',
    USAGEConsumption: 'Forbrug',
    WATERUSAGE: 'Vandforbrug',
    NILMTOOLTIPHEADER: 'Ikke-påtrængende belastningsovervågning (NILM)',
    NILM: 'NILM',
    ENERGYDISAGGREGATION: 'Energiopdeling',
    ENERGYUSAGEOVERVIEW: 'Oversigt over energiforbrug',
    CONSUMPTIONOVERVIEW: 'Forbrugsoversigt',
    LOADING: 'Henter',
    SUBMITTING: 'Indsender',
    NODATAAVAILABLE: 'Der er ingen data for den valgte periode',
    UTILITYYEAROUTOFRANGE: 'Vælg venligst datointerval inden for et år',
    NOTSUBSCRIBED: 'Intet abonnement',
    CONNECTIONERROR:
      'Vi kunne ikke oprette forbindelse til\nservice. Prøv igen',
    CONNECTIONERRORTITLE: 'Forbindelsesfejl!',
    WATERTOOLTIPHEADER: 'Vandforbrug',
    CARBONSAVINGSMETERHEADER: 'Udledninger efter kategori',
    CARBONKPIDETAILS: 'CO2-udledninger for',
    ENERGYUSAGEDETAILS: 'Energiforbrug for',
    WATERUSAGEDETAILS: 'Vandforbrug for',
    CarbonSavingMeter: 'Besparelser efter forsyning',
    SITENAMESHEADER: 'Opdeling efter steder',
    CARBONTOOLTIPHEADER: 'CO2-udledning',
    GASTOOLTIPHEADER: 'Energibesparelser på gas',
    ALLTOOLTIPHEADER: 'Energibesparelser',
    METEROVERVIEW: 'Måleroversigt',
    METERANALYSIS: 'Måleranalyse',
    ID: 'ID',
    TYPE: 'Type',
    DEVIATION: 'Afvigelse',
    HIGH: 'Høj({unit})',
    HIGHWITHOUTUNIT: 'Høj',
    LOW: 'Lav({unit})',
    LOWWITHNOUNIT: 'Lav',
    ENERGY: 'Energi({unit})',
    ENERGYNOUNIT: 'Energi',
    CHANGE: 'Ændring',
    CARBONTAB: 'CO2 (CO2e)',
    ENERGYTAB: 'Energi',
    WATERTAB: 'Vand',
    EUITAB: 'EUI',
    UTILITYCOST: 'Forsyning',
    actualConsumption: 'FAKTISK FORBRUG',
    actualCons: 'FAKTISK FORB.',
    baselineConsumption: 'BASISFORBRUG',
    baselineCons: 'BASISFORBRUG',
    ConsumptionSavingsPercentage: '% FORB. BESPARELSER',
    ConsumptionChange: 'FORB. ÆNDRING',
    ConsSavings: 'FORB. BESPARELSER',
    utiltactualCost: 'FAKTISK OMKOSTNING',
    utilpreviousCost: 'FOREGÅENDE OMKOSTNING',
    SavingsPercentage: '% BESPARELSER',
    utilchange: 'ÆNDRING',
    NODATA: 'Ingen data',
    ENERGYKPIDETAILS: 'El-ydelse for',
    ENERGYPERFORMANCEALL: 'Energiydelse',
    NILMENERGYUSAGE: 'Energiforbrug',
    NILMENERGYUSAGESUBHEADER:
      'Grafen viser energiforbruget over den valgte periode',
    ALLKPICARDDETAILS: 'Energiydelse for',
    WATERCONSUMPTIOND: 'Vandforbrug for',
    ENERGYCONSUMPTIONMETER: 'Forbrug efter måler',
    WATERCONSUMPTION: 'Vandforbrug',
    ALLUTILITIES: 'Alle forsyninger',
    ALLEnergySources: 'Alle energikilder',
    WaterPerformance: 'Vandydelse',
    WaterOverview: 'Oversigt over vandforbrug',
    GASPERFORMANCE: 'Gasydelse for',
    GASPERFORMANCEDETAILS: 'Gasydelse',
    WATERPERFORMANCEDETAILS: 'Vandydelse',
    SEWERAGEPERFORMANCE: 'Kloakydelse',
    ALLSAVINGSBYUTILITY: 'BTU-besparelser efter forsyning',
    TOTALENERGYCOST: 'Samlede energiomkostninger',
    TOTALSAVINGS: 'Samlede besparelser',
    TOTALFOOTSPRINT: 'Samlet fodaftryk',
    INTEGRATIONTYPE: 'INTEGRATIONSTYPE',
    UTILITYPROVIDER: 'FORSYNINGSSELSKAB',
    ACCOUNTNUMBER: 'KONTONUMMER',
    STATUS: 'STATUS',
    UDSSTATUS: 'Månedlig DS-status',
    IDSSTATUS: 'Interval DS-status',
    ACTIONS: 'HANDLINGER',
    SERVICESOVERVIEW: 'Oversigt over tjenester',
    AddService: 'TILFØJ TJENESTE',
    AllServices: 'Alle tjenester',
    Active: 'Aktiv',
    Inactive: 'Inaktiv',
    Sewerage: 'Kloakering',
    ServiceProvider: 'Tjenesteudbyder',
    AccountNumber: 'Kontonummer',
    CANCEL: 'ANNULLER',
    SELECTALL: 'Vælg alle',
    SEARCH: 'Søg',
    SHOWACCOUNTNUMBERS: 'Vis alle kontonumre',
    BACK: 'TILBAGE',
    SUBMIT: 'SEND',
    Complete: 'FULDFØR',
    DONE: 'UDFØRT',
    Utillity: 'Forsyning',
    AllUtilityService: 'Alle forsyningstjenester',
    Weather: 'Vejr',
    WeatherServices: 'Vejrtjenester',
    Weatherdata: 'Vejrdata kan integreres, hvis dine konti sammenkædes',
    CONFIGURE: 'KONFIGURER',
    METERID: 'MÅLER-ID',
    SERVICETYPE: 'TJENESTETYPE',
    METERINGPURPOSE: 'MÅLEFORMÅL',
    SITESETTINGS: 'Webstedsindstillinger',
    SERVICESINTEGRATION: 'Tjenester',
    USERMANAGEMENT: 'Brugeradministration',
    GENERALSETTINGS: 'Generelle indstillinger',
    UTILITYBILLTOOLTIPHEADER: 'Forsyningsregninger',
    UTILITYBILLDETAILSTOOLTIPHEADER: 'Forsyningsydelse',
    ELECTRICITYTOOLTIPHEADER: 'Energibesparelser på el',
    WATERTOOLTIPCONTENT:
      'Sammenligning af faktiske data for vandforbrug i den valgte varighed i forhold til basisårsdata',
    UTILITYBILLOVERVIEWTOOLTIPCONTENT:
      'Omkostninger beregnet for den valgte varighed ud fra faktiske data i forhold til tidligere års data. Bemærk - Prisen beregnes baseret på kalendermåneder og ikke specifik for forsyningsfaktureringsperioder.',
    UTILITYBILLTOOLTIPCONTENT:
      'Forbrug og omkostninger beregnet for den valgte varighed ud fra faktiske data i forhold til forrige års data. Bemærk - Prisen beregnes baseret på kalendermåneder og ikke specifik for forsyningsfaktureringsperioder.',
    CARBONTOOLTIPCONTENT:
      'Beregnede udledninger i faktiske værdier i den valgte varighed i forhold til forrige års data. ',
    DATANEEDEDCONTENT:
      'Omfang 1-data mangler, gennemgå og opdater data hver måned',
    CARBONTOOLTIPSECONDCONTENT:
      'CO2-beregninger i realtid er baseret på hovedmåleren, og de nøjagtige CO2-beregninger opdateres efter generering af forsyningsomkostninger.',
    CARBONTOOLTIPSUTILITY:
      'Beregnede udledninger i faktiske værdier i den valgte varighed i forhold til forrige års data. Faktiske kulstofemissionsberegninger er baseret på den leverede forbrugsregning.',
    CARBONTOOLTIPLIVE:
      'Emission beregnet for den valgte varighed ud fra faktiske data i forhold til tidligere års data fra onsite-måleren. C02-beregninger i realtid er baseret på hovedmåleren.',
    CARBONTOOLTIPINTRVAL:
      'Beregnede udledninger i faktiske værdier i den valgte varighed i forhold til forrige års data. Beregninger af den faktiske CO2-udledning er baseret på data om forsyningsintervaller.',
    ELECTRICITYTOOLTIPCONTENT:
      'Besparelser for elektricitet beregnet for den valgte varighed ud fra faktiske data i forhold til basisårdata',
    DATANEEDED1:
      'Utilstrækkelige data - Omfang 1-data skal opdateres hver måned.',
    GASTOOLTIPCONTENT:
      'Besparelser for gas beregnet for den valgte varighed ud fra faktiske data med hensyn til basisårdata',
    ALLTOOLTIPCONTENT:
      ' Besparelser beregnet for den valgte varighed ud fra faktiske data i forhold til basisårdata',
    UTILITYVIEWDETAILSTOOLTIP:
      'Forbrug og omkostninger beregnet for den valgte varighed ud fra faktiske data i forhold til forrige års data. Bemærk - Forbruget og omkostningerne er beregnet baseret på kalendermåneder og ikke specifikt for forsyningsfaktureringsperioder.',
    EMAASENERGYUSAGETOOLTIP:
      'Forbrug beregnet for den valgte varighed ud fra faktiske data i forhold til data fra basisåret',
    EMAASENERGYUSAGETOOLTIPPREV:
      'Forbrug beregnet for den valgte varighed ud fra faktiske data i forhold til forrige års data',
    EMAASCONSUMPTIONTOOLTIP:
      'Forbrug beregnet for den valgte varighed baseret på faktiske data sammenlignet med data fra baseline eller tidligere år',
    EMAASWATEROVERVIEWTOOLTIP:
      'Forbrug beregnet for den valgte varighed baseret på faktiske data sammenlignet med forrige års data',
    EMAASNILMTOOLTIP:
      'Bestem fordelingen af dit steds energiforbrug efter udstyrstyper',
    PORTFOLIOSUMMARYTOTALSAVINGSTOOLTIP:
      'Samlede omkostningsbesparelser fra energiselskaber i den valgte varighed',
    PORTFOLIOSUMMARYEUITOOLTIP:
      'EUI er en indikator for energieffektiviteten af en bygnings design og/eller drift. EUI måles som porteføljens samlede energiforbrug divideret med porteføljens samlede kvadratfod i løbet af et år.',
    SITESUMMARYEUITOOLTIP:
      'EUI er en indikator for energieffektiviteten af ​​en bygnings design og/eller drift. EUI måles som stedets samlede energiforbrug i de sidste 12 måneder divideret med stedets samlede bruttoareal.',
    PORTFOLIOSUMMARYEUITOOLTIPHEADER: 'EUI (energiforbrugsintensitet)',
    SUMMARYEUITOOLTIPHEADERFORSITE: 'EUI (energiforbrugsintensitet) - {date}',
    PROVIDERLISTPLACEHOLDER: 'Søg efter udbyderoplysninger',
    PORTFOLIOSUMMARYHEADER: 'Oversigt over CO2 og energi',
    PORTFOLIOSUMMARYHEADERLASTUPDATEDON: 'Senest opdateret den {date}',
    AIModelDetails: 'Oplysninger om AI-model',
    DATAUPLOAD: 'Dataupload',
    ADDFUEL: 'Tilføj brændstof',
    ADD: 'Tilføj',
    ADDCOMPOUND: 'Tilføj komponent',
    ADDMETEREDGAS: 'Tilføj målt gas',
    ADDSCOPETWO: 'Tilføj Omfang 2',
    EXCEEDEDLIMIT: 'overskred den maksimale grænse op til 4',
    DETAILS: 'Detaljer',
    DATAUPLOADDETAILS:
      'Få adgang til alle de funktioner, der kræver manuel input/upload af datafiler',
    DATAUPLOADCECARDSUBTITLE:
      'Spor brugen af ​​scope 1 CO2-emissioner for at opfylde din virksomheds præstationsmål for bæredygtighed.',
    DATAUPLOADCARBONESUBTITLE:
      'Denne side indeholder en omfattende tabel med forskellige brændstoffer, deres tilsvarende mængder og de tilhørende kulstofemissionsfaktorer for det valgte år.',
    SCOPEONETWOSUBTITLE:
      'Denne side indeholder en detaljeret tabel med Omfang 1-udledninger (direkte udledninger, herunder stationær forbrænding og kølemidler) og Omfang 2-udledninger (indirekte udledninger fra elektricitet) sammen med deres mængder og tilhørende CO2-udledningsfaktorer for det valgte år.',
    METERDATASUBHEADER:
      'Få adgang til alle dine uploadede datafiler med målerdata.',
    DATAMISSINGALERTS: 'Advarsler for manglende data',
    UPLOAD: 'Bulk upload',
    UPLOADTOPADD: 'Upload fil',
    PUBLISHFILE: 'Offentliggøre',
    BASELINEFILE: 'Basis',
    BASELINE_SUCCESS: 'Baselinetræning påbegyndt med succes',
    UPLOADTOP: 'Upload',
    UPLOADFILE: 'UPLOAD',
    NAME: 'Navn',
    DATATYPE: 'Datatype',
    CREATEDON: 'Oprettet den',
    DATEOFUPLOAD: 'Dato for upload',
    ALLUPLOADS: 'Alle uploads',
    STATIONARYCOMBUSTION: 'Stationær forbrænding',
    REFRIGERANTS: 'Kølemidler',
    WHEATHERDATA: 'Vejrdata',
    UTILITYBILL: 'Forsyningsregning',
    SCOPE2: 'Omfang 2',
    METEREDGAS: 'Målt gas',
    NOFILESADDEDHEADER: 'Der er endnu ingen tilføjede filer.',
    NOFILESADDEDMESSAGE:
      'Kom i gang ved at uploade vejr-, forsynings- eller punktdata',
    UPLOADBUTTON: 'UPLOAD',
    METER_DATA: 'Målerdata',
    UTILITY_BILL: 'Forsyningsregning',
    FUEL_NAME: 'BRÆNDSTOFNAVN',
    SEARCHFOR: 'Søg efter',
    EnergyManagementSiteDashboardPortfolioTitle:
      'Oversigt over kulstof og energi',
    CHOOSEDATATYPEMESSAGE:
      'Vælg datatype nedenfor for at downloade skabelonen, og fortsæt til næste trin for at uploade filer.',
    UPLOADMETERDATASTEPONEMESSAGE: 'Trin 1: Download målerdataskabelon',
    UPLOADMETERDATA: 'Upload målerdata',
    FILEUPLOADNOTE:
      'Bemærk: Kun filer af typen {type} accepteres, og ingen fil må være større end {size}MB.',
    UPDATEDFILEUPLOADNOTE:
      'Bemærk: Kun CSV-filer accepteres, og filen må ikke overstige 5 MB.',
    INSTRUCTIONSFORFILLINGTHETEMPLATE:
      'Instruktioner til upload af skabelonen.',
    INSTRUCTIONTEMPLATEONE:
      'Start med at uploade historiske måleraflæsningsdata ved hjælp af den medfølgende CSV-skabelon.',
    INSTRUCTIONTEMPLATEONEPOINTFIVE:
      'Sørg for, at de uploadede dataværdier er i den enhed, der er konfigureret i det eksterne bygningsstyringsstem i forhold til målerne',
    INSTRUCTIONTEMPLATEFIVE:
      'Brugeren kan maksimalt uploade 10 filer under uploaden, og den samlede filstørrelse må ikke overstige 1,5 GB.',
    INSTRUCTIONTEMPLATETWO:
      'Brugeren kan uploade data for maksimalt 2 år med 1, 3, 5 eller 15 minutters interval og en filstørrelse på op til 1,5 GB.',
    INSTRUCTIONTEMPLATETHREE:
      'Bemærk venligst, at dashboard og rapporter viser de historiske målerdata for de sidste 15 dage, og alle målerdata, der uploades, vil blive brugt til at træne en basismodel af god kvalitet',
    INSTRUCTIONTEMPLATEFOUR: 'Se eksempel på udfyldt CSV-skabelon',
    UPLOAD_PROGRESS_IN_TOAST:
      'Uploadfremskridt kan ses i widgetten nederst på skærmen.',
    PUBLISHMODALHEADER: 'Klar til at publicere?',
    ERRORINPUBLISHING:
      'Der opstod en fejl under publiceringen af ​​filerne. Prøv igen om lidt',
    WARNINGNOTIFICATIONFORPUBLISH: 'Yderligere filer uploades i øjeblikket',
    WARNINGINSTRUCTIONFORPUBLISHFILE:
      'Vil du hellere vente med at publicere eller fortsætte med at publicere {filesToPublish}-filer?',
    NOTEFORPUBLISHFILE:
      'Bemærk: Vi giver dig besked via e-mail, når publiceringen er udført, og viser kun de historiske målerdata for de seneste 15 dage i dashboard/rapporter.',
    INSTRUCTIONFORPUBLISHFILE: 'Vil du publicere de uploadede filer?',
    DOWNLOAD_METER_DATA_CSV_TEMPLATE: 'Download CSV-skabelon til målerdata',
    PUBLISHBUTTON: 'Ja, publicer',
    METERDATAPUBLISHINGMSG:
      'Vent, mens vi publicerer dataene. Vi giver dig besked via e-mail, når det er gjort.',
    METERDATAUPLOADFAILED:
      'Upload mislykkedes for fil: {fileName}. Prøv igen om lidt',
    METERDATAUPLOADSUCCESS: 'Filen {fileName} blev uploadet',
    NOBUTTON: 'Nej',
    METERUPLOADINSTRUCTIONTITLE: 'Instruktioner til upload af målerdata',
    METERUPLOADDOWNLOADCSV: 'Download CSV-skabelon',
    METERUPLOADDOWNLOADEXCEL: ' Download CSV-skabelon',
    METERUPLOADINSTRUCTIONONE:
      'Start med at uploade historiske måleraflæsningsdata ved hjælp af den medfølgende CSV-skabelon. ',
    METERUPLOADINSTRUCTIONFOUR:
      'Sørg for, at de downloadede data fra supervisor ikke overstiger 1,5 GB. Se de angivne præferencer for datastørrelse. ',
    METERDATAEXCELDOWNLOAD: 'Download Excel-fil med estimeringer',
    METERUPLOADINSTRUCTIONTWO:
      'Når du har uploadet CSV-filer for alle/ønskede målere på stedet, skal du klikke på knappen "Publicer" for at behandle og udfylde historiske data.',
    METERUPLOADINSTRUCTIONTHREE:
      'Klik på "Handling for basisværdi" for at fastlægge en basisværdi, og angiv det ønskede datainterval, så træner Forge AI basisværdien ved hjælp af tilgængelige, publicerede, historiske data.',
    CHOOSEDATATYPE: 'Vælg Datatype',
    NEXTUPLOAD: 'Næste - upload',
    UPLOADDATA: 'Upload data',
    ADDNEWFUEL: 'Føj nyt brændstof til',
    ADDNEWCOMPOUND: 'Føj ny komponent til',
    MANUALINPUT: 'MANUELT INPUT',
    UPLOADDATACAPS: 'UPLOAD AF DATA',
    ADDNEWFUELSUB:
      'Vælg mellem nedenstående muligheder for at indtaste eller uploade skabelonen manuelt',
    SCOPEONESC: 'Stationær forbrænding: Tilsæt brændstof',
    SCOEONEREF: 'Kølemidler: Tilføj komponent',
    SCOPETWO: 'Omfang 2',
    UPLOADING: 'Uploader',
    FILES: 'filer',
    FILE: 'fil',
    UPLOADINGMESSAGE1:
      'Oplysningerne om uploadforløbet og status for disse filer er synlige i toastmeddelelsen nederst i midten af skærmen.',
    REDIRECTMESSAGE1: 'Du bliver omdirigeret om',
    REDIRECTMESSAGE1OCR: 'Du vil snart blive omdirigeret',
    REDIRECTMESSAGE2: 'sek.',
    UPLOADFILES: 'Upload filer til',
    UPLOADMETERDATASTEPTWOMESSAGE: 'Trin 2: Upload filer til målerdata',
    UPLOADNOTE:
      'Der accepteres kun filer af typen {type}, og hver fil må ikke overstige {size} MB',
    UPDATEDUPLOADNOTE:
      'Kun én CSV-fil accepteres, og filen må ikke overstige 1,5 GB',
    UPDATEDUPLOADNOTESUB: '(kun én upload mulig ad gangen)',
    INSTRUCTIONBUTTON: 'Eksempel på udfyldt CSV-skabelon',
    FILEUPLOADPLACEHOLDER: 'Træk og slip filer her',
    SINGLEFILEUPLOADPLACEHOLDER: 'Træk og slip filen her',
    TOTALSIZEEXCEEDSERROR: 'Samlet størrelse overskrider grænsen (1,5 GB)',
    NUMBEROFFILEALLOWED: 'Du kan uploade op til 10 filer',
    FILEUPLOADPLACEHOLDERONLYONEFILE: '(kun én upload mulig ad gangen)',
    REMOVE: 'Fjern',
    CHOOSESERVICE: 'Vælg Service',
    CONNECT: 'Opret forbindelse',
    NEXT: 'Næste',
    CHOOSEUTILITYTYPE:
      'Vælg forsyningsselskab, legitimationsoplysninger og kontooplysninger for at integrere data.',
    CHOOSEUTILITYTYPEMANUAL:
      'Indtast forsyningsselskab og kontooplysninger for at uploade forsyningsdata manuelt.',
    EDITDETAILNOTE:
      'Indtast de korrekte konto- og måleroplysninger nedenfor. Klik derefter på "Send" for at opdatere og gemme dem.',
    EDITDETAILWHENBILLEXISTS:
      'Indtast de korrekte konto- og måleroplysninger nedenfor. Klik derefter på "Send" for at opdatere og gemme dem.',
    SEARCHPROVIDER: 'Søg efter forsyningsselskab',
    CONTACTSUPPORT:
      'Kan du ikke finde forsyningsselskabet? Kontakt Honeywells support.',
    UTILITYPROVIDERLABEL: 'Forsyningsudbyder',
    SERVICEPROVIDERNAME: 'TJENESTEUDBYDER',
    INTEGRATIONTYPENAME: 'INTEGRATIONSTYPE',
    UTILITYSERVICES: 'Forsyningstjenester',
    UtilityHandoffNotification:
      'Integrationstypen for {manualCount} forsyningstjenestekonto kan konverteres fra "Manuel" til "Automatiseret". Dette vil aktivere automatisk opdatering af forbrugsregninger, uden at du behøver at foretage dig noget. Find muligheden i menuen "Handlinger" i tabellen nedenfor.',
    UTILITYSERVICESDETAILS:
      'Integrer og administrer flere tjenester for at anvende data automatisk på en hurtig og intelligent måde.',
    ADDUTILITYSERVICE: 'Tilføj forsyningstjeneste',
    ADDUTILITYTYPE: 'Type af forsyningstjenesteintegration',
    AUTOMATEDTEXT:
      'Angiv venligst dine legitimationsoplysninger til "forsyningsselskabs"-kontoen for at aktivere automatisk månedlig hentning af dine elregningsdata.',
    MANUALTEXT:
      'Hvis du ikke har legitimationsoplysninger til din tjenesteudbyder, og du skal opdatere dine oplysninger om forsyningsregninger manuelt hver måned.',
    MANUAL: 'Manuel',
    AUTOMATED: 'Automatiseret',
    ADD_UTILITY_SERVICE: 'Tilføj forsyningstjeneste',
    UTILITYTYPES: 'Forsyningstyper',
    NOACCOUNTADDEDHEADER: 'Der er endnu ikke tilføjet nogen forsyningskonti.',
    NOACCOUNTADDEDMESSAGE:
      'Kom i gang ved at integrere konti for at administrere regninger og takster',
    ADDACCOUNTNUMBER: 'Tilføj',
    SELECTUTILITY: 'Vælg en forsyning',
    ACCNUMBER: 'Kontonummer*',
    UTILITYPROVIDERERROR:
      'Forsyningsselskab blev ikke fundet. Kontakt venligst din Honeywell Manager for at få hjælp til at konvertere denne konto',
    PASSWORD: 'Adgangskode*',
    USERNAME: 'Brugernavn*',
    SIGNIN: 'Log ind',
    UTILITYPROVIDERTOOLTIPTXT:
      'Indtast navnet på forsyningsudbyderen som nævnt på forsyningsregningen.',
    VERIFICATIONINPROCESS: 'Verifikation i gang',
    VERIFICATIONMSSG1: 'Kontoverificeringen tager 2-3 dage.',
    UPDATECREDENTIALS: 'Opdater legitimationsoplysninger',
    UPDATECREDENTIALSNOTE:
      'Indtast den opdaterede adgangskode til "Navn på tjenesteudbyder" for at aktivere din konto.',
    ENTERCREDENTIALS: 'Indtast legitimationsoplysninger',
    ENTERCREDENTIALSNOTE:
      'Brug dine legitimationsoplysninger til "Navn på tjenesteudbyder" for at sammenkæde kontoen.',
    PLEASEUSESERVICE:
      'Brug dine legitimationsoplysninger til "Tjenesteudbyder" for at sammenkæde kontoen.',
    FILEEMPTYERRORMSG: 'Fejl! Filen er tom. Upload igen.',
    FILESIZEERRORMSG:
      'Filstørrelsen overstiger 50 MB. Reducer filstørrelsen, og prøv igen.',
    FILEMAXSIZEERRORMSG:
      'Filstørrelsen overstiger {maxSize}. Reducer filstørrelsen, og prøv igen.',
    FILEHEADERERROR:
      'Filen har ugyldige overskrifter. Brug venligst den medfølgende skabelon og upload igen.',
    CSVFILEINVALID:
      'Data/navn for den uploadede CSV-fil er ugyldige. Tjek venligst filen og prøv igen.',
    CSVFILEINVALIDNAME:
      'Den uploadede CSV-fil er ugyldig. Specialtegn eller flerdobbelte filtypenavne er ikke tilladt.',
    DEACTIVATEACCOUNT: 'Deaktiver konto',
    DEACTIVATEUDSACCOUNT: 'Deaktiver månedlig dataservice',
    DEACTIVATEIDSACCOUNT: 'Deaktiver IDS (Interval Data Service)',
    REACTIVATEACCOUNT: 'Genaktiver konto',
    REACTIVATEIDSACCOUNT: 'Genaktiver IDS (Interval Data Service)',
    CONVERTTOAUTOMATIC: 'Konverter til "Automatisk"',
    MANAGEBILLDETAILS: 'Administrer fakturaoplysninger',
    MANAGETARIFFDETAILS: 'Administrer tariffer',
    EDITACCOUNTDETAILS: 'Rediger kontooplysninger',
    EDIT_ACCOUNT_DETAILS: 'Rediger kontooplysninger',
    ADD_METERS: 'Tilføj målere',
    UTILITY_TYPES: 'Forsyningstyper',
    CONVERT_INTEGRATION_TYPE: 'Konverter integrationstype',
    ACCOUNT_NUMBER: 'Kontonummer',
    BILLING_CYCLE: 'Faktureringscyklus',
    PERIOD: 'Periode',
    EDITACCOUNTDETAILSTOOLTIP:
      'Brugeren kan redigere alle felter, hvis der ikke er uploadet nogen regninger.',
    EDITACCOUNTDETAILSTOOLTIPFORAUTOMATIC:
      'Brugeren har ret til at redigere kontonummeret',
    CONVERTINTRGRATIONTYPE: 'Konverter til "Automatisk"',
    ENABLEIDS: 'Aktiver IDS (Interval Data Service)',
    DELETE: 'Slet',
    DELETING: 'Sletter',
    DEACTIVATECONFIRMATIONNOTE:
      'Er du sikker på, at du vil deaktivere kontonummer',
    DEACTIVATEIDSCONFIRMATIONNOTE:
      'Er du sikker på, at du vil deaktivere IDS (Interval Data Service) for kontonummer',
    REACTIVATECONFIRMATIONNOTE:
      'Er du sikker på, at du vil genaktivere kontonummer',
    REACTIVATEIDSCONFIRMATIONNOTE:
      'Er du sikker på, at du vil genaktivere IDS (Interval Data Service) for kontonummer',
    DEACTIVATEUTILITYACCOUNTMSSG:
      'Når kontoen er deaktiveret, vil applikationen ikke automatisk hente oplysninger om forbrugsregningen, og kun de historiske oplysninger vil blive gemt.',
    DEACTIVATEIDSACCOUNTMSSG:
      'Når IDS er deaktiveret, vil applikationen ikke automatisk hente oplysninger om forsyningsintervallet, og kun de historiske data vil blive gemt.',
    REACTIVATEUTILITYACCOUNTMSSG:
      'Når kontoen er genaktiveret, vil programmet automatisk hente oplysninger om forsyningsregningen.',
    REACTIVATEIDSUTILITYACCOUNTMSSG:
      'Når IDS er genaktiveret, vil programmet automatisk hente oplysninger om forsyningsintervallet.',
    YES: 'Ja',
    NO: 'Nej',
    REVERIFYNOTE:
      'Angiv dine legitimationsoplysninger til "Tjenesteudbyder" for at sammenkæde kontoen.',
    REVERIFYHEADER: 'Bekræft legitimationsoplysninger og kontonummer',
    REVERIFY: 'Genbekræft',
    UPDATE: 'Opdater',
    REENROLL: 'Genaktiver konto',
    save: 'GEM',
    ACCOUNTMISSINGHEADER: 'Opdater kontonummer',
    ACCOUNTMISSINGNOTE:
      'Angiv legitimationsoplysninger og kontonummer for "Tjenesteudbyder" for at sammenkæde kontoen.',
    SHOWMORE: 'Vis mere',
    NORESULTS: 'Ingen resultater fundet.',
    BREAKDOWNBYSITE: 'Opdeling efter sted ({count})',
    PORTFOLIOENERGY: 'Energi',
    PORTFOLIOENERGYCONS: 'Energiforbrug',
    PORTFOLIOCONSUMTION: 'Forbrug',
    PORTFOLIOWATER: 'Vand',
    PORTFOLIOWATERCONS: 'Vandforbrug',
    ENERGYUSAGEBYSITE: 'Energiforbrug efter steder ({count})',
    SITEWITHDATA: '* Kun steder med data vises i tabellen',
    ELECTRICITYUSAGEBYSITE: 'Elforbrug efter steder ({count})',
    GASUSAGEBYSITE: 'Gasforbrug efter steder ({count})',
    WATERUSAGEBYSITE: 'Vandforbrug efter steder ({count})',
    ENERGYOPTIMIZATION: 'Intelligent bygningsoptimering',
    ENERGYOPTIMIZATIONNEW: 'Energy Optimization',
    ENERGYOPTIMIZATIONEO: 'Energy Optimization (EO)',
    ENERGYOPTIMIZATIONSAVINGS: 'IBO-besparelser',
    EOSETTINGSUBTITLE:
      'EO overvåger, måler og optimerer løbende bygningens VVS-system for at opnå det laveste energiforbrug i alle situationer og minimere den energi, der bruges til opvarmning og køling af et anlæg.',
    EOSETTINGMODALHEADER: 'Inaktiv energioptimering?',
    EOSETINGMODALCONTENT:
      'Den intelligente bygningsoptimering vil ikke foretage løbende overvågning, måling og optimering af VVS-systemet i dit anlæg for at opnå det laveste energiforbrug.',
    EOSETINGMODALCONTENTSUB:
      'Er du sikker på, at du vil inaktivere energioptimering?',
    EOENABLETITLE: 'Aktivér energioptimering for dette sted.',
    EOSTATUSMESSAGESUCCESS:
      'Intelligent bygningsoptimering er aktiveret for dette sted.',
    EOSTATUSMESSAGEERROR:
      'Intelligent bygningsoptimering er deaktiveret for dette sted.',
    EOSETTINGNODATAAVAILABLE:
      'Kontakt venligst systemadministratoren, konfigurationen er ikke færdig.',
    CURRENTEOSTATUS: 'Nuværende EO-status: ',
    ON: 'Til',
    OFFMANUALSWITCHEDOFF: 'Fra - manuelt slukket',
    OFFLINE: 'Offline',
    EONotOptimizing: 'EO ikke optimering',
    OFFPLANNEDOFFFORIMPROVINGBASELINE:
      'Fra - planlagt Fra for at forbedre basisværdi',
    SwitchedOfffromCloud: 'Slukket fra Cloud',
    SwitchedOfffromSite: 'Slukket fra stedet',
    EOON: 'EO On-status angiver den aktuelle optimeringsstrategi i brug',
    EOMANUALSWITHCHEDOFF:
      'Sætpunktet er ikke blevet anvendt, siden EO blev slukket manuelt',
    PLANNEDOFFFORBASELINE: 'EO er planlagt Fra for at forbedre basisværdi',
    STATUSNOTAVAILABLE: 'Status ikke tilgængelig',
    STATUSNOTAVAILABLETOOLTIP:
      'Statusoplysninger er ikke tilgængelige på nuværende tidspunkt. Kontakt venligst Honeywell- connectedbuildingsupport@honeywell.com for at løse denne tilstand',
    EOOFFLINE:
      'EO Off-status angiver, at optimeringsstrategi ikke er i brug på grund af optimeringsfejl',
    SwitchedOfffromCloudToolTip:
      'EO er manuelt slukket fra skyen. Kontakt venligst Honeywell- connectedbuildingsupport@honeywell.com for at få hjælp til at aktivere det igen',

    SwitchedOfffromSiiteToolTip: 'EO er manuelt slukket af brugeren fra stedet',
    EOSavings: ' Intelligente bygningsoptimeringsbesparelser',
    EOUtility_all: 'Alle forsyninger',
    EOUtility_electricity: 'Elektricitet',
    EOUtility_gas: 'Gas',
    EOUtility_steam: 'Damp',
    EOUtility_chilledwater: 'Afkølet vand',
    EOUtility_hotwater: 'Varmt vand',
    inactiveDays: 'Inaktive dage',
    inactiveDay: 'Inaktiv dag',
    excludedDays: 'Udelukkede dage',
    excludedDay: 'Udelukket dag',
    activeHours: 'Aktive timer',
    activeDay: 'Aktiv dag',
    savingsSummaryEO:
      'Anslåede besparelser (med {opertionalPercentage} % EO-driftstid)',
    operationalTimeEO: 'Med {opertionalPercentage}% EO-driftstid',
    timeUsedForBaselining: '{baseline}% tid brugt til basisværdi',
    siteComfort: 'Site komfort',
    activeStrategyStatus: 'Aktiv',
    inactiveStrategyStatus: 'Inaktiv',
    lastUpdated: 'Senest opdateret:',
    CALCULATED: 'Basis',
    ESTIMATEDSAVINGS: 'Anslåede besparelser',
    OPPORTUNITYFROMEO: 'Mulighed fra EO',
    EMAASEOSTATETOOLTIP:
      'Aktiv eller inaktiv status angiver den aktuelt anvendte optimeringsstrategi.',
    EOSAVINGTOOLTIP:
      'Energibesparelser, når intelligent bygningsoptimering blev kørt, sammenlignet med beregnet energiforbrug.',
    EOSAVINGONENABLE: 'Besparelser på IBO-aktiverede dage',
    EOSAVINGENTIREPERIOD: 'Besparelser over hele perioden',
    EONEGATIVEORZEROSAVINGSMESSAGE:
      'Ingen besparelser inden for det valgte tidsinterval. Overvej at udvide den valgte varighed til en længere periode for at få et overblik over de anslåede besparelser.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIP:
      'Beregnet forbrug i faktiske værdier i den valgte varighed i forhold til basisårsdata. EUI beregnes ved hjælp af energidata fra forsyningsregninger.',
    EMAASPORTFOLIOENERGYUSAGETOOLTIPPREV:
      'Forbrug beregnet for den valgte varighed ud fra faktiske data i forhold til forrige års data. EUI beregnes ved hjælp af energidata fra forsyningsregninger.',
    EMAASPORTFOLIOCONSUMPTIONTOOLTIP:
      'Forbrug beregnet for den valgte varighed baseret på faktiske data sammenlignet med basisdata eller forrige års data. EUI beregnes ved hjælp af energidata fra forsyningsregninger.',
    CEMSPORTFOLIO_UTIL_LIVE_CONSUMP_TOOLTIP:
      'Forbruget beregnes for den valgte periode ud fra faktiske data sammenlignet med tidligere data eller basisdata for henholdsvis forsyningsselskab og live-måler. Månedligt forbrug er baseret på den gennemsnitlige daglige energi fra elregninger, normaliseret for hele måneder, når den spænder over to måneder.',
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_TOOLTIP:
      'Forbruget beregnes for den valgte periode ud fra de faktiske data sammenlignet med basisdata fra måleren på stedet.',
    CEMSPORTFOLIO_DATA_SOURCE_INTERVAL_TOOLTIP:
      'Forbruget beregnes for den valgte periode ud fra de faktiske data sammenlignet med basisdata fra forsyningsselskabets intervaldata.',
    CEMSPORTFOLIO_DATA_SOURCE_LIVE_WATER_TOOLTIP:
      'Forbruget beregnes for den valgte periode ud fra de faktiske data sammenlignet med de forrige data fra måleren på stedet.',
    CEMSPORTFOLIO_DATA_SOURCE_UTIL_TOOLTIP:
      'Forbruget beregnes for den valgte periode ud fra de faktiske data sammenlignet med data fra forrige periode fra forsyningsregninger. Månedligt forbrug er baseret på gennemsnitlig daglig energi fra elregninger, normaliseret for hele måneden, når regningen strækker sig over to måneder.',
    PORTFOLIOEUI: 'EUI ({unit})',
    PORTFOLIOWATERChange: 'Ændring',
    PORTFOLIOSITECOUNT: 'Opdeling efter sted ({count})',
    UTILITYCOSTBYSITES: '{Utility}-omkostninger efter steder ({count})',
    ALLUTILITYCOSTBYSITES: 'Forsyningsomkostninger efter steder ({count})',
    SOLAR: 'Sol',
    WIND: 'Vind',
    SOLARPERFORMANCE: 'Solydelse',
    WINDPERFORMANCE: 'Vind ydeevne',
    UTILITYCOSTOVERVIEW: 'Oversigt over forsyningsomkostninger',
    DESCRIPTIONNOTIFICATION:
      'Du har nået det maksimale antal forsyningskonti for samme forsyningstype. Kontakt din administrator for at oprette flere konti.',
    TITLENOTIFICATION: 'Kontogrænsen er nået.',
    ENERGYUSAGECAPS: 'ENERGIBRUG',
    UPDATEERRORMESSAGE: 'Noget gik galt. Prøv igen senere.',
    MANUALTOAUTOMATICCONVERSION:
      'Kontokonvertering fra manuel til automatisk er igangsat.',
    APPLY: 'ANVEND',
    RESET: 'NULSTIL',
    CLOSE: 'LUK',
    SCOPE1FUELTYPES: 'Omfang 1-brændstoftyper',
    SCOPE1FILTERSUBHEADER: 'Filter ændrer kun grafisk visning',
    SCOPE1DATAMISSING: 'Data for Omfang 1 mangler',
    SCOPE1SHOWMISSINGDATA: 'Gennemgå de manglende data for Omfang 1 og opdater',
    FUELGASTYPE: 'Brændstof-/gastype',
    COMPOUNDTYPE: 'Sammensat type',
    UTILITYTYPE: 'Forsyningstype',
    FUELGASTYPESELECT: 'Vælg en brændstof-/gastype',
    COMPOUNDSELECT: 'Vælg sammensætningstype',
    UTILITYSELECT: 'Vælg forbrugstype',
    EMISSIONFACTOR: 'CO2-udledningsfaktor',
    SelectCategory: 'Vælg kategori',
    UNIT: 'Enhed',
    UNITSELECT: 'Vælg en enhed',
    StationaryCombustion: 'Stationær forbrænding',
    YEAR: 'År',
    Country: 'Land',
    State: 'Stat',
    YEARSELECT: 'Vælg et år',
    MONTH: 'Måned',
    Override: 'Tilsidesæt',
    MONTHSELECT: 'Vælg en måned',
    ADDDATA: 'Tilføj data',
    NOFUELCONSUMED: 'Intet brændstof forbrugt ',
    NOCONSUMED: 'Intet forbrug',
    QUANTITY: 'Mængde',
    QUANTITYENTER: 'Indtast antal',
    COSTSCOPE: 'Omkostninger',
    COSTENTER: 'Indtast omkostninger',
    EDIT: 'Rediger',
    YEARCHECK: 'år',
    MONTHERROR: 'Vælg en anden måned',
    SUCCESS: 'Dataopdatering gennemført',
    CO2FACTORROOLTIPHEADER: 'CO2-udledningsfaktor',
    PLEASENOTE: 'Bemærk: ',
    PLEASENOTETEXT:
      'Den nye CO2-udledningsfaktor vil blive brugt i den næste CO2-udledningsberegning. Allerede beregnede CO2-emissionsværdier ville ikke blive genberegnet med den nye værdi.',
    CO2FACTORROOLTIPCONTENT:
      'Det er den mængde CO2, der frigives til atmosfæren pr. forbrugt energienhed',
    CO2FACTORSCCONTENT:
      'Det er den mængde CO2, der frigives til atmosfæren pr. forbrugt energienhed. Indtast den tilsvarende værdi i kgCo2e/mmbtu for den valgte enhed.',
    CO2FACTORRFCONTENT:
      'Det er den mængde CO2, der frigives til atmosfæren pr. forbrugt energienhed. Indtast den tilsvarende værdi i MTCo2e/mmbtu for den valgte enhed.',
    CO2FACTORSCOPETWOANDGASCONTENT:
      'Det er den mængde CO2, der frigives til atmosfæren pr. forbrugt energienhed. Indtast værdiækvivalenten for den valgte enhed.',
    FUELTABLETEXT: 'Nedenstående brændstoftyper tilhører Omfang 1-udledninger',
    METEREDGASHEADER:
      'Nedenstående forsyningstyper tilhører Omfang 1-udledninger',
    SCOPETWOHEADER:
      'Nedenstående forsyningstyper tilhører Omfang 2-udledninger',
    UNITDROPDOWNNAME: 'Enhed',
    COMPOUNDTABLETEXT:
      'Nedenstående sammensætningstyper tilhører Omfang 1-udledninger',
    ENERGYCONSUMPTIONNILM: 'Energiforbrug',
    ENERGYCONSUMPTIONSECONDHEADERNILM:
      'Grafen viser energiforbruget og dets fordeling over den valgte periode',
    ENERGYCONSUMPTIONBYEQUIPMENTTYPE: 'Energiforbrug efter udstyrstype',
    METERNAME: 'Målernavn*',
    METERNUMBER: 'Målernummer*',
    CONSUMPTIONUNIT: 'Forbrugsenhed',
    DEMANDUNIT: 'Efterspørgselsenhed',
    CURRENCYUNIT: 'Valutaenhed',
    TOTALMETERS: 'SAMLET ANTAL MÅLERE',
    METERNAMECHANGEDESCRIPTION:
      "Nedenfor er listen over måler-id'er knyttet til kontoen",
    METERNAMEUPDATESUCCESS:
      'Måler-ID: ({meterId}) er blevet omdøbt til "({meterName})"',
    METERNAMECHARACTERS: 'Brug kun alfanumeriske tegn',
    METERNAMEMAXLENGTH: 'Maksimal længde: {maxCh} tegn',
    NILMDROPDOWNALLMETERS: '',
    BILLBREAKDOWN_OVERVIEW: 'Forbrugsoversigt ({rate})',
    DEMAND_OVERVIEW: 'Efterspørgselsoversigt {rate}',
    DEMAND: 'Efterspørgsel',
    CONSUMPTION_RATE_OVERVIEW: '{name} Oversigt ({rate})',
    ELECTRICITYBLENDEDRATE: 'Blandet elpris ({rate})',
    BILLBREAKDOWN_COST_OVERVIEW: '{utilityName} Omkostningsoversigt ({rate})',
    BILLBREAKDOWN_COST_TOOLTIP_HEADER: 'Elomkostninger ({rate})',
    COST: 'Forbrugsoversigt',
    SUMMARY: 'Oversigt',
    PDF: 'PDF',
    MANAGE_COLUMNS: 'Administrer kolonner',
    RESET_ALL_FILTERS: 'Nulstil alle filtre',
    DOWNLOAD_CSV: 'Download CSV',
    DOWNLOAD_PDF: 'Vis og download PDF',
    UTILITY_BILL_ANALYSIS: '{utilityName} Regningsanalyse',
    NOTIFICATIONBOXFORMONTHLY:
      'Analyse af elregningen kommer med månedsvisning og visninger for faktureringsperioden.  Månedlig visning beregner forbrugsregningen fra begyndelsen til slutningen af måneden på forholdsmæssig basis. Eksempel (1. maj 2022-31. maj 2022). Derimod beregner visning for faktureringsperioden forbrugsregningen i henhold til faktisk faktureringscyklus. Eksempel (22. maj 2022-22. juni 2022). Klik på faktureringsperioden for at se data i henhold til den faktiske faktureringscyklus.',
    SUMMARYTABLEAPIONGOING:
      'Opsummeringstabeller behandles gruppevis. Klik, når alle tabeldata er indlæst.',
    NOTIFICATIONFORBILLINGPERIOD:
      'Visning for faktureringsperioden beregner forbrugsregningen i henhold til faktisk faktureringscyklus. Eksempel (22. maj 2022-22. juni 2022).',
    VIEW_OVERVIEW: 'Vis oversigt',
    FILE_DELETED_SUCCESSFULLY: 'Filen blev slettet',
    FILE_DELETEING_ERROR: 'Fejl ved sletning af filen. Prøv igen om lidt.',
    AVG_CONSUMP_PER_MTH: 'Gennemsnitligt forbrug pr. måned',
    AVG_CONSUMP_PER_DAY: 'Gennemsnitligt forbrug pr. dag',
    MTHLY_CONSUMP_PER_SQFT: 'Månedligt forbrug pr. kvadratfod',
    EnableIDSText:
      'Indtast legitimationsoplysningerne for at bekræfte kontoen. Klik på Send for at aktivere IDS.',
    EnableIDSHeaderTxt: 'Aktiver IDS (Interval Data Service)',
    EOSAVINGS: 'EO-besparelser',
    EOSUMMARY: 'EO-oversigt',
    REASONFOROFFLINE: 'Reason for Off - Details'
  },
  alarmConfiguration: {
    ALARMTYPE: 'Alarmtype',
    CONFIGUREALARMDESCLINE1:
      'Vælg alarmtypen for målere, der skal konfigureres',
    CONFIGUREALARMDESCLINE2:
      'Vælg alarmtypen for målere for at udløse alarmer, hvis energiforbruget overstiger basisværdien i det nævnte interval.',
    ALLMETERS: 'Alle målere ',
    SEARCHALARMTYPE: 'Vælg alarmtypen',
    SEARCHMETERS: 'Søg efter måler',
    THRESHOLDSETTINGS: 'TÆRSKELINDSTILLINGER',
    NOMETERSSELECTED:
      'Vælg mindst én af målerne på venstre\npanel for at ændre tærskelværdier.',
    THRESHOLDALARM: 'TÆRSKELALARM',
    ALARMNAME: 'Alarmnavn',
    MINTHRESHOLD: 'Minimumstærskel',
    MAXTHRESHOLD: 'Maksimumstærskel',
    TO: 'til',
    RESETTODEFAULTS: 'Nulstil til standardværdier',
    SAVE: 'GEM',
    NOMETERSUNDERSITE: 'Der er ingen tilgængelige målere',
    NOSITESAVAILABLE: 'Der er ingen tilgængelige steder',
    VALIDATIONREQUIRED:
      'Der skal vælges mindst én prioritet, og alle input under den skal udfyldes',
    VALIDATIONOVERLAPPING:
      'De indtastede data er enten ugyldige eller overlapper med andre værdier'
  },
  urjanetStatus: {
    ENROLLED: 'Tilmeldt',
    ENROLLEDMSG: 'Det lykkedes at trække data ud fra kontoen',
    SUCCESSFUL_DELIVERED: 'Succesfuldt leveret',
    SUCCESSFUL_DELIVEREDMSG:
      'Det lykkedes at udtrække og levere data fra kontoen',
    PRODUCTION: 'Produktion',
    PRODUCTIONMSG: 'Konto er i drift',
    Active: 'Aktiv',
    ACTIVEMSG:
      'Der findes en manuel konto, og brugeren kan indtaste manuelle regninger.',
    Enroll_Successful: 'Enroll_Successful',
    FAILEDLOGIN: 'Loginfejl',
    NEEDSCREDENTIAL: 'Legitimationsoplysninger påkrævet',
    NEEDSCREDENTIALMSG:
      'Der er ikke knyttet nogen legitimationsoplysninger til kontoen',
    FAILEDTOACCESS: 'Det lykkedes ikke at få adgang.',
    NEEDSTEMPLATE: 'Kræver skabelon',
    NEEDSTEMPLATEMSG:
      'Kontoen har legitimationsoplysninger, men disse oplysninger har ikke fået tildelt en skabelon',
    UNDERREVIEW: 'Under gennemgang',
    UNDERREVIEWMSG: 'Fejler med generisk status',
    WEBSITEISSUE: 'Problem med websted',
    WEBSITEISSUEMSG: 'Kontoen kan ikke oprette forbindelse til webstedet',
    CAPTCHALOGIN: 'Captcha login',
    CAPTCHALOGINMSG: 'Login er blokeret af Captcha på hjemmesiden',
    TEMPLATEFAILURE: 'Skabelonfejl',
    TEMPLATEFAILUREMSG:
      'Der var et problem med skabelonen, som forhindrede en vellykket udtrækning',
    NEEDSENROLLMENT: 'Kræver tilmelding',
    NEEDSENROLLMENTMSG: 'Kontoen skal tilmeldes',
    NOBILL: 'Ingen regning',
    NOBILLMSG: 'Der er ingen regning på webstedet for kontoen',
    REENROLLED: 'Tilmeldt igen',
    REENROLLEDMSG: 'Kontoen tilmeldes igen efter deaktivering',
    NAVIGATIONFAILURE: 'Navigationsfejl',
    NAVIGATIONFAILUREMSG: 'Skabelonrettelse påkrævet for disse konti',
    SOURCEFORMATCHANGE: 'Ændring af kildeformat',
    SOURCEFORMATCHANGEMSG: 'Der er fundet et nyt regningsformat',
    ACCOUNTNUMBERCHANGE: 'Ændring af kontonummer',
    ACCOUNTNUMBERCHANGEMSG: 'Kontonummeret ændret til det nye',
    USERACTIONREQUIRED: 'Brugerhandling_påkrævet',
    USERACTIONREQUIREDMSG: 'Handling påkrævet fra Kunden',
    MIGRATION: 'Migration',
    MIGRATIONMSG: 'Konto migreret med ny udbyder/kontonummer',
    INITIALTEMPLATEDEVELOPMENT: 'Indledende_skabelonudvikling',
    INITIALTEMPLATEDEVELOPMENTMSG: 'Skabelonen er under udvikling',
    REJECTED: 'Afvist',
    REJECTEDMSG: 'Konti afvist, da disse ikke er gyldige at behandle',
    EBILLENROLLMENT: 'Tilmelding til e-faktura',
    EBILLENROLLMENTMSG:
      'Konto, for hvilken e-bill-tilmelding er påkrævet/afventer',
    CREDENTIALUPDATED: 'Legitimationsoplysninger opdateret',
    CREDENTIALUPDATEDMSG:
      'Legitimationsoplysningerne er blevet opdateret efter fejl. Kontobekræftelsesprocessen tager 2/3 dage.',
    TEMPLATEUPDATED: 'Skabelon opdateret',
    TEMPLATEUPDATEDMSG:
      'Skabelonen er blevet opdateret, men er ikke blevet testet',
    UNKNOWN: 'Ukendt',
    UNKNOWNMSG: 'Kontostatus er ukendt',
    PENDINGMSG: 'Kontostatus venter',
    PENDING: 'Venter',
    DELETED: 'Slettet',
    DELETEDMSG: 'Kontoen er blevet slettet',
    ENROLLMENTFAILUREMSG: 'Fejl ved tilmelding af konto',
    ENROLLMENTFAILURE: 'Tilmeldingsfejl',
    DOESNOTEXIST: 'Findes_ikke',
    DOESNOTEXISTMSG: 'Konto findes ikke',
    ACCOUNTNUMBERMISMATCHMSG: 'Kontonummer stemmer ikke overens',
    ACCOUNTNUMBERMISMATCH: 'Kontonummer stemmer ikke overens',
    CONVERSIONINPROGRESS: 'Konvertering i gang',
    CONVERSIONINPROGRESSMSG:
      'Kontokonvertering i gang fra manuel til automatisk',
    FAILEDTOACCESSMSG:
      'Udtrækning returnerede intet (kan være ny hjemmeside eller ødelagt navigation)',
    FAILEDTOACCESSMSGIDS:
      'Det lykkedes ikke at få adgang til intervaldata fra forsyningsvirksomheden',
    FAILEDLOGINMESSAGE:
      'Navigationen mislykkedes specifikt ved login-trinnet (tjek bruger/adgangskode)',
    ACCOUNTMISSING: 'Kontoen mangler',
    ACCOUNTMISSINGMESSAGE:
      'Legitimationsoplysningerne blev brugt og fungerede på en vis måde, men der var ingen spor af denne konto',
    CONNECTIONERROR: 'Forbindelsesfejl',
    CONNECTIONERRORMESSAGE:
      'Noget gik galt. Indtast "Tjenesteudbyder"-legitimationsoplysningerne for kontoen igen.',
    CONNECTIONERRORMESSAGEIDS: 'Noget gik galt.',
    BLOCKED: 'Kontoen er blokeret',
    BLOCKEDMESSAGE: 'Login er blokeret.',
    INACTIVE: 'Kontoen er inaktiv',
    INACTIVEMESSAGE: 'Kontoen er inaktiv.',
    FINALLED: 'Kontoen er lukket',
    FINALLEDMESSAGE:
      'Gennemgå kontoen, og afmeld kontoen, hvis den ikke længere skal behandles.',
    VERIFICATIONINPROG: 'Verificering er i gang',
    VERIFICATIONINPROGIDS: 'Aktivering er i gang',
    REENROLLMENTPROG: 'Ny tilmelding i gang',
    REACTIVATIONPROG: 'Genaktivering i gang',
    SUBMITTED: 'Indsendt',
    SUBMITTEDMSG: 'Oprindelig kontotilstand; skal automatisk fortsætte',
    NOMINATEDPROG: 'Nomineret',
    METERSMISMATCHED: 'MålereMatcherIkke',
    METERSMISMATCHEDMSG:
      'Måleroplysningerne stemmer ikke overens. Opdater venligst i Rediger kontooplysninger.',
    VERIFICATIONINPROGMESSAGE: 'Kontoverificeringen tager 2-3 dage.',
    VERIFICATIONINPROGMESSAGEIDS: 'Kontoverificeringen tager 2-3 dage.',
    REENROLLMENTTOOLTIP:
      'Ny tilmelding på denne konto påbegyndes igen efter deaktivering',
    REACTIVATIONTOOLTIP:
      'Genaktivering af denne IDS-konto er påbegyndt igen efter deaktivering',
    NOMINATEDMESSAGE:
      'Kontoen har de nødvendige legitimationsoplysninger, men de er endnu ikke blevet kørt',
    DATAUNAVAILABLE: 'Dataudtræk mislykkedes',
    STATEMENTMISSING: 'Erklæring mangler',
    DATAUNAVAILABLEMESSAGE:
      ' Der blev udtrukket data, men de blev ikke gemt på grund af revisionsfejl, lagerfejl eller lignende.',
    STATEMENTMISSINGMSG:
      'Det lykkedes at bruge legitimationsoplysningerne, og kontoen blev set på webstedet, men vi kunne ikke udtrække data',
    NOTENROLLED: 'Ikke tilmeldt',
    NOTENROLLEDMESSAGE:
      'Det lykkedes at udtrække kontoen, men den pågældende konto er ikke tilmeldt',
    DEACTIVATED: 'Deaktiveret',
    DEACTIVATEDMESSAGE: 'Kontoen er ikke længere aktiv.',
    REVIEWACCOUNTANDUNS:
      'Gennemgå kontoen, og afmeld kontoen, hvis den ikke længere skal behandles',
    ERROR: 'Fejl',
    ERRORMESSAGE: 'Noget gik galt. Kontakt din administrator.',
    LOGINFAILURE: 'Login-fejl',
    LOGINFAILUREMESSAGE:
      'Login mislykkedes på grund af ændring af adgangskode, eller også er tjenesteudbyderens konto udløbet.',
    DEACTIVATIONINITIATEDMSSG: 'Deaktivering påbegyndt.',
    DEACTIVATIONINITIATED: 'Deaktivering i gang',
    REENROLLEDREQUIRED: 'Gentilmelding påkrævet',
    REENROLLEDREQUIREDMSG:
      'Det er nødvendigt med en ny tilmelding til kontoen. Angiv legitimationsoplysningerne igen ved at klikke på opdater.',
    ENABLEIDSMSG: 'IDS (Interval Data Service) er blevet aktiveret med succes.',
    INTERVALSNOTSUPPORTED: 'Ikke understøttet',
    INTERVALSNOTSUPPORTEDMSG:
      'Intervaldata er ikke understøttet af forsyningsudbyderen for denne konto.',
    PLUGNEWACCOUNTMSG: 'Kontoen er blevet tilmeldt med succes',
    PLUGEMAILAPPROVALMSG:
      'Kontobekræftelse er i gang, og Arcadia kræver e-mailgodkendelse fra kunden',
    PLUGCREDENTIALISSUEMSG:
      'Fejl ved adgang til intervaldata fra forsyningsvirksomheden på grund af legitimationsoplysninger',
    PLUGNODATAAVAILABLEMSG:
      'Det lykkedes ikke at få adgang til intervaldata fra forsyningsvirksomheden, da der ikke var nogen data tilgængelige',
    PLUGUNSUCCESSFULEMAILAPPROVALMSG:
      'Det lykkedes ikke at få adgang til intervaldata fra forsyningsvirksomheden, da e-mailgodkendelsen ikke var vellykket',
    PLUGINVALIDCREDENTIALSMSG:
      'Forbindelsesfejl på grund af ugyldige legitimationsoplysninger'
  },
  virtualMeters: {
    SELECTED: 'Elmålere - udvalgte ({count})',
    SEARCHMETERS: 'Søg efter målernavn',
    METERGROUPDETAILS: 'OPLYSNINGER OM MÅLERGRUPPE',
    METERGROUPNAME: 'Navn på målergruppe',
    DESCRIPTION: 'Beskrivelse',
    DESCRIPTIONPLACEHOLDER: 'Maks. 240 tegn',
    VALIDATIONREQUIRED:
      'Der skal vælges mindst to målere, og begge felter skal udfyldes',
    SAVE: 'GEM',
    CANCEL: 'ANNULLER'
  },
  DetailedView: {
    TOTALEMISSIONS: 'Samlede udledninger',
    TOTALEMISSION: 'Samlet udledning',
    SCOPEONETITLE: 'CO2-udledninger efter Omfang 1',
    SCOPETWOTITLE: 'CO2-udledninger efter Omfang 2',
    SCOPE1: 'Omfang 1',
    SCOPE2: 'Omfang 2',
    SCOPEONEDATANOTCONSIDER: 'Omfang 1-data skal opdateres',
    CARBONTITLE: 'Oversigt over CO2-udledninger',
    PORTFOLIOCARBONTITLE: 'Portefølje - CO2-udledninger (CO2e)',
    TOTALEMISSIONSTOOLTIP:
      'Beregnede udledninger i faktiske værdier i den valgte varighed i forhold til forrige års data.',
    CARBONTOOLTIPSUTILITYDETAIL:
      'Emission beregnet for den valgte varighed fra faktiske værdier i forhold til forrige års data. Faktiske CO2-emissionsberegninger er baseret på forsyningsregningen.',
    CARBONTOOLTIPLIVEDETAIL:
      'Emission beregnet for den valgte varighed fra faktiske værdier i forhold til forrige års data fra måleren på stedet. Real-time C02-beregninger er baseret på hovedmåleren.',
    CARBONTOOLTIPINTRVALDETAIL:
      'Emission beregnet for den valgte varighed fra faktiske værdier i forhold til forrige års data. Faktiske CO2-emissionsberegninger er baseret på intervaldata fra forsyningsselskabet.',
    SCOPEONETOOLTIP:
      'Direkte udledning beregnet i faktiske værdier i den valgte varighed i forhold til forrige års data.',
    SCOPETWOTOOLTIP:
      'Indirekte udledning beregnet i faktiske værdier i den valgte varighed i forhold til forrige års data.',
    SCOPEONETOOLTIPUTILITY:
      'Direkte emission beregnet for den valgte varighed fra faktiske værdier i forhold til forrige års data. Faktiske CO2-emissionsberegninger er baseret på forsyningsregningen.',
    SCOPEONETOOLTIPINTERVAL:
      'Direkte emission beregnet for den valgte varighed fra faktiske værdier i forhold til forrige års data. Faktiske CO2-emissionsberegninger er baseret på intervaldata fra forsyningsselskabet.',
    SCOPEONETOOLTIPLIVE:
      'Direkte emission beregnet for den valgte varighed fra faktiske værdier i forhold til forrige års data fra måleren på stedet. Real-time C02-beregninger er baseret på hovedmåleren.',
    SCOPETWOTOOLTIPdUTILITY:
      'Indirekte emission beregnet for den valgte varighed fra faktiske værdier i forhold til forrige års data. Faktiske CO2-emissionsberegninger er baseret på forsyningsregningen.',
    SCOPETWOTOOLTIPINTERVAL:
      'Indirekte emission beregnet for den valgte varighed fra faktiske værdier i forhold til forrige års data. Faktiske CO2-emissionsberegninger er baseret på intervaldata fra forsyningsselskabet.',
    SCOPETWOTOOLTIPLIVE:
      'Indirekte emission beregnet for den valgte varighed fra faktiske værdier i forhold til forrige års data fra måleren på stedet. Real-time C02-beregninger er baseret på hovedmåleren.',
    CARBONDETAILKEY: 'oplysninger om CO2',
    SCOPEONEKEY: 'detailSummaryWithoutCurrency',
    UTILITYDETAILKEY: 'utilitydetail',
    METER: 'MÅLER',
    METERNAME: 'METERS NAVN',
    FUELTYPE: 'BRÆNDSTOFTYPE',
    SITES: 'STEDER',
    SOURCE: 'KILDE',
    CURRENTAVOIDANCE: 'AKTUEL REDUKTION',
    PREVIOUSAVOIDANCE: 'FOREGÅENDE REDUKTION',
    UTILITYTYPE: 'FORSYNINGSTYPE',
    ACTUALEMISSION: 'FAKTISKE UDLEDNINGER',
    ACTUALEMIS: 'FAKTISK UDL.',
    PREVIOUSEMISSION: 'TIDLIGERE EMISSIONER',
    PREVIOUSPERIOD: 'TIDLIGERE EMIS.',
    PREVIOUSEMISSIONS: 'Tidligere emissioner',
    PORTFOLIOPREVIOUSConsumption: 'TIDLIGERE PERIODE',
    PORTFOLIOACTUALEMISSION: 'FAKTISKE UDLEDNINGER',
    PORTFOLIOPREVIOUSEMISSION: 'FORRIGE UDLEDNINGER',
    PORTFOLIOPREVIOUSCOST: 'FORR. OMKOSTN.',
    CHANGE: 'ÆNDRING',
    ACTUALCONS: 'FAKTISK FORB.',
    BASELINECONSP: 'BASISFORBRUG',
    PREVPERIOD: 'FORRIGE PERIODE',
    CHANGEPERCENT: '%ÆNDRING',
    EUICURRENT: 'AKTUEL EUI',
    EUIPRVPERIOD: 'FORRIGE EUI PERIODE',
    PORTFOLIOACTUALCOST: 'FAKTISK OMKOSTNING',
    SAVINGS: 'BESPARELSER',
    FuelType: 'Brændstoftype',
    Emissions: 'UDLEDNINGER',
    CARBONAVOIDANCE: 'CO2-reduktion',
    carbonEmissionsAvoidance: 'Reduktion af CO2-udledninger',
    TOTALAVOIDANCETOOLTIP:
      'CO2-reduktion beregnet for den valgte varighed ud fra faktiske data i forhold til forrige års data.',
    Meters: 'Målere',
    ActivePower: 'Aktiv strøm',
    ActivePowerContent: 'Øjeblikkelig effekt målt på et bestemt tidspunkt.',
    AVGpower: 'Gennemsnitlig effekt',
    PeakPower: 'Spidsbelastning',
    PeakPowerContent: 'Maksimalt strømbehov for det valgte datointerval.',
    LoadType: 'Belastningstype',
    LoadTypeContent: 'Den type belastning, som måleren er forbundet med.',
    FifteenMinuteElectricConsumption: '15 min. forbrug.',
    FifteenMinuteElectricConsumptionPrediction: '15 min. foruds.',
    ElectricityConsumption: 'Samlet energiforbrug',
    EnergyConsSelectedPeriod: 'Energiforbrug for valgt periode',
    EnergyConsToday: 'Energiforbrug i dag',
    EnergyConsTodayContent: 'Samlet energiforbrug i dag.',
    EnergyConsMonth: 'Energiforbrug for måneden',
    EnergyConsMonthContent: 'Samlet energiforbrug for den aktuelle måned.',
    TotalEnergyConsumption: 'Samlet energiforbrug',
    TotalEnergyConsumptionContent: 'Målernes samlede forbrug',
    EnergyConsSelectedPeriodContent: 'Energiforbrug for valgt periode',
    DataQuality: 'Datakvalitet',
    BaselineQuality: 'Basiskvalitet',
    PowerDemand: 'Strømbehov',
    APPLYBASELINEFROMDATEINVALID:
      'Vælg venligst en dato, der ikke er ældre end de seneste 15 dage',
    INVALIDEXCLUSIONRANGESELECTION:
      'Vælg en udelukkelsesdato inden for det valgte datointerval for træning'
  },
  NILM: {
    NILMModalHeader: 'Tilmeld dig NILM',
    NILMMeterDetails: 'Tilføj NILM-detaljer',
    SmartXMeter: 'Vis udskrift',
    NILMDetailsTabHeader:
      'Indtast venligst dine NILM-måleroplysninger (Non-Instrusive Load Monitoring - ikke-påtrængende belastningsovervågning)) for at tilføje dem i HBSM',
    NILMDetailsTabSubHeader: 'NILM-måleroplysninger',
    NILMMeterId: 'Data-ID/UUID',
    NILMDISAGGREGATEDMETERID: 'Opdelt data-ID/UUID (valgfrit)',
    NILMMeterName: 'Målernavn',
    NILMAddMeter: 'Tilføj måler',
    NIMAssignMainMeter: 'Tildel som hovedmåler',
    NILMNextButton: 'Næste',
    NILMSubmitButtom: 'Send',
    NILMCancelButton: 'Annuller',
    NILMcardheader: 'Ikke-påtrængende belastningsovervågning (NILM)',
    NILMcardsubheader:
      'Bestem fordelingen af dit steds energiforbrug efter udstyrstyper',
    NILMRedirect: 'Du bliver omdirigeret om 5 sek.',
    NILMAccountVerification: 'Kontobekræftelse i gang',
    NILMAccountVerificationSuccess: 'Kontobekræftelse er gennemført',
    INVALIDNILMMETERID: 'ugyldigt målerinstallations-ID',
    METERNAMEINVALID: 'målernavn findes allerede for dette sted',
    NILMMainmeter: '(Tildelt som hovedmåler)',
    NILMsmartXmeterheader:
      'Dine NILM-målere vises nedenfor. Bekræft venligst for at fortsætte, og klik på send',
    NILMDUPLICATEMETERNAME: 'duplikeret målernavn',
    NILMDUPLICATEMETERID: 'duplikeret måler-ID',
    IDDUPLICATETOGETHER: 'ugyldigt og duplikeret UUID',
    NAMEDUPLICATETOGETHER: 'målernavnet findes allerede og er duplikeret'
  },
  energyStar: {
    EnergySubcriptionPeriod: 'For den 12-måneders periode, der slutter -',
    NoRecordsFound: 'Der blev ikke fundet nogen poster',
    LearnText: 'Få yderligere oplysninger',
    outOfHundred: '/100',
    CurrentScore: 'Nuværende score',
    EnergyTooltipHeader: 'Energiforbrug',
    EnergyTooltipContent:
      'Energy Star-score er en måling af, hvor godt din ejendom klarer sig i forhold til lignende ejendomme, når den er normaliseret for klima- og driftsegenskaber.',
    EnergyStarTitle: 'Energy Star-score',
    loading: 'Henter',
    ViewText: 'Se scoredetaljer',
    NA: 'Ikke relevant',
    SomethingWentWrong: 'Bemærk!',
    notifyServerError:
      'Der er en fejl på serversiden. Kontakt venligst systemadministratoren.',
    ReasonForNoScoreLabel:
      'Energy Star-score kunne ikke indlæses på grund af tekniske fejl.',
    ViewReasonForNoScore:
      'Se oplysninger om, hvorfor der ikke er nogen scoreoplysninger',
    EnergyStarNoScoreNote:
      'Den viste Energy Star-score er fra {prevMonth}, da den forrige måneds score ikke er tilgængelig.',
    EnergyStarNoScoreNoContentMessage:
      'Der blev ikke fundet en årsag til manglende scoreoplysninger!',
    EnergyStarNoScoreForLastMonthLabel:
      'Energy Star-scoren kunne ikke indlæses for den forrige måned. Derfor er den viste score fra den seneste måned.'
  },
  equipmentSpaceMapping: {
    FILE_NOT_ACCEPTED:
      '"{fileName}" er et ugyldigt filformat. Kun .{extension}-filformatet accepteres',
    INVALIDFILE_EXTENSION:
      'Ugyldigt filtypenavn. Brug venligst en gyldig {extension}-fil.',
    INVALIDFILE_MIME:
      'Ugyldig fil mime-type. Brug venligst fil med gyldige mime-typer: {mimeTypes}.',
    INVALIDFILE_MAXALLOWEDSIZE: 'Filstørrelsen skal være mindre end {size}',
    INVALIDFILE_MINALLOWEDSIZE: 'Filstørrelsen skal være større end {size}',
    INVALIDFILE_UNKNOWNERROR:
      'Der opstod en fejl ved forsøget på at få adgang til filoplysningerne. Kan ikke validere',
    INVALID_SCHEMA_REQUIRED_HEADERS:
      'Den uploadede Excel-fil har ugyldige kolonner. Brug venligst passende skabelon og genupload excel-filen.',
    INVALID_SCHEMA_LIST_REQ_HEADERS:
      'Påkrævede overskrifter: {requiredSubHeaders}',
    EMPTY: '',
    NO_DATA: 'Filen har ingen data',
    INVALID_DATA_CONTENT: 'Første datarække skal indeholde et rumligt element',
    SOME_ERROR_EXCEL_READ:
      'Der opstod en fejl under læsning af Excel-filen. Fejl: {errorString}',
    SOME_ERROR_GENERAL:
      'Der opstod en fejl. Genvælg og upload en gyldig fil. Fejldetaljer -> {errorString}',
    PROPERTY_INVALID_DATA_TYPE: 'Ugyldig datatype. Tilladt: {type}',
    NAME_INVALID_SPECIAL_CHAR: 'Navnet har et ugyldigt specialtegn',
    NAME_INVALID_MAX_LEN: 'Maks. {len} tegn tilladt',
    SPATIAL_ELE_NEW: 'Nyt område oprettes',
    NO_ASSOC_REMOVE:
      'Ingen VAV/bevægelsessensor tilknyttet. Fjern venligst denne post',
    PROPERTIES_INVALID: 'Nogle egenskaber er ugyldige',
    SPATIAL_ELEMENT_NAME_MISMATCH:
      'I det angivne rumlige element-id ({id}) stemmer navnet fra arket og registreret på stedet ({dbSpEleName}) ikke overens',
    ELEMENT_NAME_MISMATCH:
      'For det angivne element-id ({id}) stemmer navnet fra arket og registreret på stedet ({dbEleName}) ikke overens',
    DUPLICATE_ENTRIES: 'Flere poster med samme navn',
    MULTIPLE_EQUIPMENTS_SAME_NAME:
      'Stedet har flere udstyrsgenstande registreret med samme navn. Omdøb dette udstyr til et unikt navn, der skal tilknyttes',
    ELEMENT_ID_DNE: '{type} med angivet id ({id}) findes ikke',
    SPATIAL_ELEMENT_ID_DNE: 'Område med angivet id ({id}) findes ikke',
    ELEMENT_TYPE_NAME_DNE: '{type} med dette navn findes ikke',
    PROPERTY_DNE:
      'Ejendommen med navnet {name} findes ikke. Kontroller venligst'
  },
  ZLOOnboardingConfig: {
    UPLOAD_CARD_TITLE_ZLO: 'Rumtilknytning og konfiguration til ZLO-udstyr',
    UPLOAD_CARD_DESC_ZLO:
      'Upload udstyr til rumtilknytningsdata for ZLO-onboarding og konfiguration',
    UPLOAD_MODAL_TITLE: 'Upload ZLO-onboardingdata',
    VALIDATE_DATA: 'Upload',
    BACK_TO_UPLOAD: 'Tilbage',
    UPLOAD_TAB_TOP_NOTE:
      'Download skabelonen, og udfyld oplysningerne om det rumlige element sammen med udstyrsrelaterede detaljer i skabelonen, før du fortsætter med at uploade',
    UPLOAD_TAB_DOWNLOAD_TEMPLATE_BTN: 'Download XLSX-skabelon',
    UPLOAD_TAB_SECOND_NOTE: '(Det er kun muligt at uploade én fil ad gangen)',
    UPLOAD_TAB_PLACEHOLDER: 'Træk og slip en fil her',
    VALIDATING_FILE_DATA: 'Validering af fildata',
    READING_FILE: 'Læser fil',
    VALIDATING_FILE_SCHEMA: 'Validerer filskema',
    RETRIEVING_SITE_DATA: 'Henter steddata, som skal valideres',
    VALIDATING_DATA_ENTRIES: 'Validerer data',
    ALL_ENTRIES_VALID: 'Alle indtastninger er gyldige',
    SUBMIT_TO_PROCEED_SUBTEXT:
      'Klik venligst på indsend for at gå videre og tilmeld dig i HBSM',
    VIEW_ALL_ENTRIES: 'Se alle poster',
    FIX_VAL_ERRORS_MSG:
      'Nedenfor er de fejlagtige indtastninger af data for ZLO-onboarding og konfiguration. Vend tilbage til upload-fanen og upload Excel-filen igen uden de fejlagtige indtastninger for at registrere dig i HBSM',
    VAL_OK_SUBMIT_MSG:
      'Klik venligst på indsend for at gå videre og tilmeld dig i HBSM',
    ERROR_BOX_TEXT:
      '{numErrors} identificerede fejl. Ret dem venligst, og upload filen igen for at indsende og registrere i HBSM',
    VALIDATION_ERROR_TITLE: 'Valideringsfejl',
    TOTAL: 'I alt',
    CURRENTLY_SHOWING: 'Viser {num} af i alt {total}',
    SHOW_ALL_ENTRIES: 'Vis alle poster',
    SL_NO: 'Sl. Nr.',
    SPATIAL_ELE_NAME: 'Navn på rumligt element',
    ELE_TYPE: 'Elementtype',
    ELE_NAME: 'Navn',
    ZLO_STATE: 'ZLO-tilstand',
    ZO_SETBACK: 'Zoneoptimeringstilbageskridt (F)',
    VAV: 'Variabel luftvolumen',
    OCCUPANCY_SENSOR: 'Belægningssensor',
    VAV_ETYPE: 'VAV',
    OCCUPANCY_SENSOR_ETYPE: 'Belægningssensor',
    SEARCH_PLACEHOLDER: 'Søg',
    SEARCH_MIN_LEN: 'Min {len} tegn',
    NO_DATA: 'Ingen data matcher din søgning',
    VALIDATING_TITLE: 'Validerer uploadet fil',
    SOME_ERROR_FETCHING_DATA:
      'Der opstod en fejl under hentning af stedsdata. Fejl: {errorString}',
    SUBMITTING_TITLE: 'Vent venligst, mens vi tilknytter udstyr til rummet',
    SUBMITTING_SUBTITLE: 'Du vil blive omdirigeret på få sekunder',
    CREATING_NEW_SPATIAL_ELEMENTS: 'Oprettelse af nye rum',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS: 'Tilknytter udstyr til rum',
    MAPPING_ELEMENT_TO_SPATIAL_ELEMENTS_ERROR_MESSAGE:
      'Fejl i tilknytning af element til rumligt element. Prøv igen senere',
    UPDATING_PROPERTIES: 'Opdatering af egenskaber',
    SUBMISSION_SUCCESS_TITLE: 'Udstyret er tilknyttet til rum',
    SUBMISSION_ERROR_TITLE: 'Fejl ved dataindsendelse',
    SUBMISSION_ERROR_MESSAGE: 'Fejl under dataindsendelse. Prøv igen senere',
    BULK_CREATION_ERROR_MESSAGE:
      'Der opstod en fejl under oprettelse af rumlige elementer. Prøv igen senere.',
    UPDATE_PROPERTY_ERROR_MESSAGE:
      'Der opstod en fejl under opdatering af egenskaber. Prøv igen senere.',
    SUBMISSION_SUCCESS_SUBTITLE:
      'VAV- og belægningssensorerne, der er tilknyttet til områder, vises under udstyrsfanen på stedets hjemmeside',
    GOTO_SITE_HOME_PAGE: 'Gå til stedets hjemmeside',
    'Items per Page': 'Rækker pr. side'
  },
  utilityBreakDown: {
    SUMMARYTABLESUBHEADER:
      'Nedenstående oplysninger vises altid i henhold til faktureringscyklus'
  },
  UtilityBuilder: {
    NEWBILL: 'Ny regning',
    ENTERDATAMANUALLY: 'Indtast data manuelt',
    BILLNAME: 'Regningsnavn',
    BILLINGDATE: 'Faktureringsdato',
    TOTAL_BILL_AMOUNT: 'Samlet regningsbeløb',
    BILLING_PERIOD_CONSUMPTION: 'Forbrugsperiode',
    BILLING_DEMAND: 'Faktureringskrav',
    ENTER_PLACEHOLDER: 'Indtast',
    SELECT_PLACEHOLDER: 'Vælg',
    CATEGORIES: 'Kategorier',
    ACCOUNTNUMBER: 'Kontonummer',
    UTILITYTYPE: 'Forsyningstype',
    BILLINGCYCLE: 'Faktureringscyklus',
    UPLOADELECTRICITYBILL: 'Upload elregning',
    UPLOADGASBILL: 'Upload gasregning',
    ADDELECTRICITYBILL: 'Tilføj elregning',
    ADDGASBILL: 'Tilføj {utilityType}-regning',
    UPLOADUTILITYBILL: 'Upload forbrugsregning',
    PDFUPLOADPROMPT: 'Upload en PDF-fil af forsyningsregningen',
    UploadElectricitybill: 'Upload elregning*',
    Utilitybill: 'Forsyningsregning',
    UPLOADBILL: 'Upload {utilityType}-regning',
    UPLOADELECTRICITYBILLNONMANDATORY: 'Upload elregning',
    FILENAMECONTAINSPACES: 'Filnavnet indeholder mellemrum.',
    FILENAMECONTAINSPECIALCHARACTER: 'Filnavnet indeholder specialtegn.',
    PDFEXTENSION: '.pdf',
    BILLCATEGORIES: 'Regningskategorier',
    REFERSAMPLEBILL: 'Se prøveregning.',
    INPUTCATEGORIES:
      'Indtast de forskellige kategorier og tilsvarende omkostninger fra din {utilityType}-regning. Hvis der er behov for hjælp til at finde dem på regningen, '
  },
  baseline: {
    baselineconfiguration: 'Basiskonfiguration',
    baselineConfigDesc:
      'Justerede basislinjer fastlægger det forventede forbrug af forsyningen for en lokalitet, baseret på en kombination af historisk forbrug, seneste tendenser og kendte påvirkninger såsom vejrvariabler.',
    baseline: 'Basis',
    total: 'I alt',
    searchPlaceholder: 'Søg efter',
    create: 'Opret baseline',
    view: 'Se baseline',
    baselineQuality: 'Basiskvalitet',
    baselinePeriod: 'Basisperiode',
    reportingPeriod: 'Rapporteringsperiode',
    estBaselinePeriod: 'Etabler basisperiode',
    baselinePeriodDescription:
      'Vælg den basis- og rapporteringsperiode, som du skal oprette en basisværdi for',
    independentVariables: 'Uafhængige variabler',
    autoSelectBest: 'Vælg automatisk de bedste variabler',
    utilityDataType: 'Forsyningsdatatype',
    calendarMonth: 'Kalendermåned',
    billingPeriod: 'Faktureringsperiode',
    tStat: 'T-stat'
  },
  utilityManagement: {
    ADD_ACCOUNT: 'TILFØJ KONTO',
    ADD_METERS: 'TILFØJ MÅLERE'
  }
};

export const nonDescriptorMessages: Record<string, string> = {
  'TOTAL BILL AMOUNT': 'Samlet regningsbeløb',
  Consumption: 'Forbrug',
  Demand: 'Krav',
  'Service Charges': 'Serviceafgifter',
  'Transmission & Distribution': 'Transmission og distribution',
  Others: 'Andre',
  'Demand Charges': 'Kravsafgifter',
  'Total Cost': 'Samlet pris',
  Total: 'Samlet'
};
